module.exports = __webpack_public_path__ + "img/sakuya izayoi lunar war servant_lw.27f03700.png";